// src/components/AvisoModal.tsx
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import avisoBanner from "../assets/img/miri.png";
import { Badge, Button } from "components/ui";


export interface AvisoModalProps {
  texto: string;
  onClose: () => void;
}

const AvisoModal: React.FC<AvisoModalProps> = ({ texto, onClose }) => {

  // bloquear scroll (igual que Modal)
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return ReactDOM.createPortal(
    <div
      className="app-scrim animate-fadeIn fixed inset-0 z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="aviso-titulo"
        className="max-h-[85vh] w-full max-w-xl overflow-y-auto rounded-card border border-gray-200/80 bg-white p-5 shadow-overlay dark:border-white/10 dark:bg-navy-800 sm:p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center gap-2">
          <Badge tone="brand">Aviso</Badge>
        </div>

        <h2
          id="aviso-titulo"
          className="sr-only"
        >
          Aviso
        </h2>

        <div className="prose prose-sm max-w-none whitespace-pre-wrap text-gray-900 dark:prose-invert dark:text-gray-200">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {texto}
        </ReactMarkdown>
        </div>

        <img
        src={avisoBanner}
        alt=""
        className="mt-5 max-h-60 w-full rounded-card object-contain"
        />

        <div className="mt-6 flex justify-end border-t border-gray-200/80 pt-5 dark:border-white/10">
          <Button variant="primary" onClick={onClose}>
            Entendido
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AvisoModal;
